var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.template)?_c('div',[_c('data-form',{staticClass:"m-a-10",attrs:{"columns":_vm.columns,"canEdit":true,"item":_vm.template.cadenceDetails}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }